import { ROUTE } from "../../routes";
import { isFromAndroidWebview, uploadToS3Bucket } from "../../configs/utils";
import { api } from "../../configs/api";
import { getAppHeader } from "../../configs/config";
import AsyncStorage from "@react-native-async-storage/async-storage";
import SharedPropsService from "../../SharedPropsService";
import { Platform, Linking } from "react-native";
import { getContentType } from "../kyc/kyc_doc_upload_POI_manual/actions";
let RNFetchBlob;
if (Platform.OS === "android") {
    RNFetchBlob = require('rn-fetch-blob');
}
export const goBack = async (action, _datastore, { goBack }) => {
    await goBack();
};
export const viewSampleDocument = async (action, _datastore, { navigate }) => {
    await navigate(ROUTE.AS_ES_SAMPLE_DOCUMENT_VIEW, {
        documentURL: action?.payload?.documentURL,
        documentType: action?.payload?.documentType
    });
};
export const downloadDocument = async (action, _datastore, { setDatastore }) => {
    const downloadURL = action?.payload?.downloadURL;
    const documentDisplayName = action?.payload?.documentDisplayName;
    const fileName = documentDisplayName.replace(/[^\w\s]/g, '').replace(/\s+/g, '_').toLowerCase();
    await setDatastore(ROUTE.AS_ES_INDIVIDUAL_DOCUMENT, "asESIndividualDocumentDC", {
        downloadDocumentLoading: true
    });
    if (Platform.OS !== "web") {
        if (Platform.OS === "ios") {
            Linking.openURL(downloadURL);
            await setDatastore(ROUTE.AS_ES_INDIVIDUAL_DOCUMENT, "asESIndividualDocumentDC", {
                downloadDocumentLoading: false
            });
        }
        else {
            try {
                const RNFetchObject = RNFetchBlob.default;
                const fs = RNFetchObject.fs;
                const downloadsDir = fs.dirs.DownloadDir;
                RNFetchObject.config({
                    fileCache: true,
                    addAndroidDownloads: {
                        useDownloadManager: true,
                        notification: true,
                        path: `${downloadsDir}/${fileName}.pdf`,
                        description: 'Downloading file...',
                    },
                }).fetch('GET', downloadURL);
                setTimeout(() => {
                    setDatastore(ROUTE.AS_ES_INDIVIDUAL_DOCUMENT, "asESIndividualDocumentDC", {
                        downloadDocumentLoading: false
                    });
                }, 2000);
            }
            catch (error) {
                setDatastore(ROUTE.AS_ES_INDIVIDUAL_DOCUMENT, "asESIndividualDocumentDC", {
                    downloadDocumentLoading: false
                });
            }
        }
    }
    else {
        fetch(downloadURL)
            .then((response) => response.blob())
            .then((blob) => {
            if (isFromAndroidWebview()) {
                window.open(downloadURL);
            }
            else {
                const url = window.URL.createObjectURL(new Blob([blob]));
                const a = document.createElement('a');
                a.href = url;
                a.download = `${fileName}.pdf`;
                document.body.appendChild(a);
                a.click();
                URL.revokeObjectURL(url);
                document.body.removeChild(a);
                setDatastore(ROUTE.AS_ES_INDIVIDUAL_DOCUMENT, "asESIndividualDocumentDC", {
                    downloadDocumentLoading: false
                });
            }
        })
            .catch((error) => {
            setDatastore(ROUTE.AS_ES_INDIVIDUAL_DOCUMENT, "asESIndividualDocumentDC", {
                downloadDocumentLoading: false
            });
            console.warn('Error download file: ', error);
        });
    }
};
export const continueAction = async (action, _datastore, { network, navigate }) => {
    let applicationId;
    if (await AsyncStorage.getItem("application_id")) {
        applicationId = await AsyncStorage.getItem("application_id");
    }
    else {
        const user = await SharedPropsService.getUser();
        applicationId = user.linkedApplications[0].applicationId;
    }
    const individualDocVerify = await network.post(`${api.individualDocVerify}${applicationId}`, {
        documentId: action?.payload?.documentId
    }, {
        headers: await getAppHeader(),
    });
    const docVerificationDetails = individualDocVerify?.data;
    if (docVerificationDetails?.status === "SUCCESS") {
        await navigate(ROUTE.AS_ES_DOCUMENTS_LISTING);
    }
};
export const uploadDocumentToS3 = async (action, _datastore, { network, setDatastore }) => {
    const fileBody = action?.payload?.fileDetails;
    const uploadDocumentPreSignedURL = action?.payload?.uploadPreSignedURL;
    const imageFileExtension = Platform.OS === 'web'
        ? fileBody.name.split('.').pop() :
        fileBody.hasOwnProperty('name')
            ? fileBody.name.split('.').pop()
            : fileBody.fileName.split('.').pop();
    if (Platform.OS !== "web") {
        uploadToS3Bucket(`${uploadDocumentPreSignedURL}`, fileBody, getContentType(imageFileExtension)).then((res) => {
        });
    }
    else {
        if (fileBody) {
            await AsyncStorage.setItem("collateralImageExtension", imageFileExtension);
        }
        await network.put(uploadDocumentPreSignedURL, fileBody, {
            headers: { 'Content-Type': getContentType(imageFileExtension) },
        }).then(response => {
            if (response.status === 200) {
            }
            else {
                setDatastore(ROUTE.AS_ES_INDIVIDUAL_DOCUMENT, "asESIndividualDocumentDC", {
                    documentUploadFailed: true
                });
            }
        });
    }
};
const downloadFile = async (fileUrl, fileName) => {
};
export const viewUploadedDocument = async (action, _datastore, { navigate }) => {
    await navigate(ROUTE.AS_ES_SAMPLE_DOCUMENT_VIEW, {
        documentURL: action?.payload?.fileUrl,
        fileName: action?.payload?.fileName,
        documentType: action?.payload?.documentType
    });
};
